import { render, staticRenderFns } from "./HistoryWechatUserData.vue?vue&type=template&id=79690a99&scoped=true"
import script from "./HistoryWechatUserData.vue?vue&type=script&lang=js"
export * from "./HistoryWechatUserData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79690a99",
  null
  
)

export default component.exports